import { useEffect, useState } from "react";
import { fetchAlerts } from "../api/fetchAlerts";

function useAssetAlert(assetIds: string[]) {
    const [alerts, setAlerts] = useState<any[]>([]);
    const [alertSidebar, setAlertSidebar] = useState(false);
    const [assetAlerts, setAssetAlerts] = useState<any[]>([]);

    useEffect(() => {
        getAlerts(assetIds);
    }, [assetIds.length]);

    const getAlerts = async (assetIds: string[]) => {
        const today = new Date();
        const startAt = new Date(today.setHours(0, 0, 0, 0)).toISOString();
        const endAt = new Date(today.setHours(23, 59, 59, 999)).toISOString();

        const bodyData = {
            pageSize: 100,
            page: 0,
            assetIds,
            tagIds: [],
            lampFilter: [],
            startAt: startAt,
            endAt: endAt,
            search: "",
            zone: "UTC-3",
        };

        const alertsResponse = await fetchAlerts(bodyData);
        setAlerts(alertsResponse ?? []);
    }

    const hasAlert = (assetId: string): boolean => {
        if (!assetId && !alerts.length) return false;
        return alerts.some((alert) => alert?.vehicleId === assetId);
    };

    const handleAlertSidebar = (assetId: string) => {
        if (!assetId) return;
        const alert = alerts?.find((alert) => alert?.vehicleId === assetId);
        const assetAlerts = alerts?.filter((alert) => alert?.vehicleId === assetId);
        if (!alert || !assetAlerts.length) return;
        setAlertSidebar(!alertSidebar);
        setAssetAlerts(assetAlerts);
    };

    const handleCloseAlertSidebar = () => {
        setAlertSidebar(false);
        setAssetAlerts([]);
    };

    return { hasAlert, handleAlertSidebar, handleCloseAlertSidebar, alertSidebar, assetAlerts };
}

export default useAssetAlert;